<template>
  <div class="x1-70">
    <div class="group-245-3">
      <div class="group-50-2">
        <div class="view-494">
          <div class="rectangle-38-1"></div>
          <h1 class="text-480 calibri-bold-black-60px">Модуль 6 <br />Недоступно</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "X1172",
};
</script>

<style>
.x1-70,
.x1-71 {
  display: flex;
  height: 367px;
  left: 1124px;
  position: absolute;
  top: 388px;
  width: 530px;
}

.group-245-3,
.group-245-4 {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 20px;
  box-shadow: 0px 18.83px 47.08px #2f327d1a;
  display: flex;
  height: 367px;
  min-width: 530px;
  padding: 54px 21px;
}

.group-50-2,
.group-50-3 {
  display: flex;
  height: 258px;
  width: 487px;
}

.view-494,
.view-495 {
  height: 258.38px;
  position: relative;
  width: 489.22px;
}

.rectangle-38-1,
.rectangle-38-2 {
  background-color: var(--nobel);
  border-radius: 20px;
  height: 258px;
  left: 0;
  position: absolute;
  top: 0;
  width: 487px;
}

.text-480,
.text-631 {
  left: 90px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 56px;
}
</style>
